// extracted by css-extract-rspack-plugin
export default {"container":"_24bb5a71","noReserve":"_15b18157","priceRow":"_892d04f1","boldCopy":"_92b2d4b6","price":"_f7982ffb","originalListPrice":"_e8262340","printHide":"_8757d27"};